import Vue from 'vue'
import VueRouter from 'vue-router'
import ChildrenPolicy from '../views/ChildrenPolicy'
import PrivacyPolicy from '../views/PrivacyPolicy'
import SDK from '../views/SDK'
import UserPolicy from '../views/UserPolicy'
import Description from '../views/Description'

Vue.use(VueRouter)

const routes = [
  {
    path: '/description',
    name: 'Description',
    component: Description,
    meta: {
      title: '使用权限说明'
    }
  },
  {
    path: '/ChildrenPolicy',
    name: 'ChildrenPolicy',
    component: ChildrenPolicy,
    meta: {
      title: '儿童隐私协议'
    }
  },
  {
    path: '/PrivacyPolicy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: '隐私政策'
    }
  },
  {
    path: '/sdk',
    name: 'SDK',
    component: SDK,
    meta: {
      title: '第三方SDK'
    }
  },
  {
    path: '/UserPolicy',
    name: 'UserPolicy',
    component: UserPolicy,
    meta: {
      title: '用户协议'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
